module.exports = __webpack_public_path__ + "img/icon74.d8e149b9.png";